<template>
  <div class="banner-video">
    <img class="bg-img" :src="vm.bg" />
    <div class="bg-mask"></div>
    <div class="content">
      <p class="title">{{ vm.type_name }}</p>
      <p class="des">{{ vm.type_des }}</p>
      <img
        v-if="vm.videlUrl"
        class="icon-play"
        :src="playIcon"
        @click="play"
        @touchstart="isHover = true"
        @touchend="isHover = false"
      />
    </div>
    <transition v-if="vm.videlUrl">
      <div class="video-box" v-show="isShow">
        <div class="video-content">
          <!-- <img class="icon-video-close" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/common/icon-video-close.png" @click="close"> -->
          <video
            webkit-playsinline="playsinline"
            playsinline="playsinline"
            x5-playsinline="playsinline"
            x5-video-player-type="h5"
            x-webkit-airplay="allow"
            controls
            class="video"
            :src="vm.videlUrl"
            ref="videoBox"
          ></video>
        </div>
        <div class="controls-box">
          <p class="">播放</p>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  props: {
    vm: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    playIcon() {
      return this.isHover
        ? "https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/play-hover.png"
        : "https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/icon-play.png";
    },
  },
  data() {
    return {
      isShow: false,
      isHover: false,
    };
  },
  methods: {
    play() {
      this.isShow = true;
      const myVideo = this.$refs.videoBox;
      myVideo.addEventListener("ended", this.close, false);
      this.$refs.videoBox.play();
    },
    close() {
      const myVideo = this.$refs.videoBox;
      myVideo.removeEventListener("ended", this.close, false);
      this.isShow = false;
      this.$refs.videoBox.pause();
    },
  },
};
</script>
<style lang="scss" scoped>
.banner-video {
  position: relative;
  .bg-img {
    width: 100%;
  }
  .bg-mask {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 5;
    background: rgba(0, 0, 0, 0.1);
  }
  .content {
    position: absolute;
    top: 43px;
    left: 38px;
    width: 320px;
    text-align: left;
    color: #f8f9fd;
    z-index: 10;
    .title {
      font-size: 18px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      line-height: 25px;
    }
    .des {
      margin-top: 6px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 17px;
    }
    .icon-play {
      margin-top: 30px;
      width: 74px;
      height: 29px;
    }
  }
  .video-box {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0px;
    left: 0px;
    background: rgba(0, 0, 0, 0.5);
    z-index: 200;
    .video-content {
      position: absolute;
      width: 100%;
      top: 0px;
      left: 0;
      .icon-video-close {
        width: 38px;
        height: 38px;
        position: absolute;
        right: 10px;
        top: 10px;
        z-index: 201;
      }
      .video {
        width: 100%;
        height: 211px;
      }
    }
  }
  .v-enter,
  .v-leave-to {
    opacity: 0;
  }
  .v-enter-to,
  .v-leave {
    opacity: 1;
  }
  .v-enter-active,
  .v-leave-active {
    transition: all 0.6s;
  }
}
</style>
